<template>
  <div class="Editdata">
    <app-header></app-header>

    <el-container style="border: 1px solid #eee">
      <app-sidebar></app-sidebar>
      <el-main>
        <app-breadcrumb></app-breadcrumb>
        <el-form
          :model="EditForm"
          :rules="rules"
          ref="EditForm"
          label-width="100px"
          class="EditdataForm"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="EditForm.name"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="EditForm.sex" placeholder="请选择性别">
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号" prop="age">
            <el-input v-model="EditForm.age"></el-input>
          </el-form-item>
          <el-form-item label="证书编号" prop="school">
            <el-input v-model="EditForm.school"></el-input>
          </el-form-item>
          <el-form-item label="职业技能" prop="fathername">
            <el-input v-model="EditForm.fathername"></el-input>
          </el-form-item>
          <el-form-item label="级别" prop="fathermobile">
            <el-input v-model="EditForm.fathermobile"></el-input>
          </el-form-item>
          <el-form-item label="头像" prop="usericon">
            <el-upload
              :action="params.action"
              :data="params.data"
              :file-list="imageList"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
          <el-form-item label="发证时间" required>
            <el-col :span="11">
              <el-form-item prop="fz_date">
                <el-date-picker
                  type="month"
                  placeholder="选择月"
                  v-model="fz_date"
                  style="width: 100%;"
                  @change="selectTime"
                  format="yyyy年M月"
                  value-format="yyyy年M月"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('EditForm')">保存</el-button>
            <el-button @click="resetForm('EditForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Editdata',
  data() {
    return {
      EditForm: {},
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        age: [
          {
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          },
          { min: 8, max: 18, message: '长度在 8 到 18 个字符', trigger: 'blur' }
        ],
        school: [
          { required: true, message: '请输入证书编号', trigger: 'blur' }
        ],
        fathername: [
          { required: true, message: '请输入职业技能', trigger: 'blur' }
        ],
        fathermobile: [
          { required: false, message: '请输入级别', trigger: 'blur' }
        ],
        fz_date: [
          {
            type: 'string',
            required: true,
            message: '请选择月份',
            trigger: 'change'
          }
        ]
      },
      fz_date: '',
      params: {
        action: '/api/user/edit_head_img/',
        data: { user_id: this.$route.query.id }
      },
      imageList: [],
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  mounted() {
    this.$http
      // dev
      // .get('/api/article/' + this.$route.query.id)
      // product
      .get('/api/article/article_detail', {
        params: { article_id: this.$route.query.id }
      })
      .then(res => {
        var rcode = res.data.code
        this.EditForm = res.data.data
        //获取上传图片路径并前端显示
        var file = {
          url: this.EditForm.picurl
        }
        //如果数据库中有上传图片路径就显示
        if (file.url) {
          this.imageList.push(file)
        } else {
          this.imageList.splice(0, 1)
        }
        // 去除年月字符
        this.fz_date = this.EditForm.fz_date
          .replace(/\u5e74/g, '-')
          .replace(/\u6708/g, '')
        // 返回并清除token信息并跳转到登录页面
        if (rcode !== 200) {
          this.$store.commit('REMOVE_COUNT')
          this.$router.push('/login')
        }
      })
      .catch(err => {
        this.$message.error(err.msg)
      })
  },
  methods: {
    selectTime(val) {
      this.EditForm.fz_date = val
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http
            // dev
            // .put('/api/article/' + this.$route.query.id, this.EditForm)
            // product
            .put(
              '/api/article/update_article?id=' + this.$route.query.id,
              this.EditForm
            )
            .then(res => {
              var rcode = res.data.code
              // 返回并清除token信息并跳转到登录页面
              if (rcode !== 200) {
                this.$store.commit('REMOVE_COUNT')
                this.$router.push('/login')
              } else {
                this.$router.push('/datalist')
                this.$message.success('保存成功！')
              }
            })
            .catch(err => {
              this.$message.error(err.msg)
            })
        } else {
          this.$message.error('保存失败！')
          return false
        }
      })
    },
    //清除输入表单信息
    resetForm(formName) {
      this.fz_date = ''
      this.$refs[formName].resetFields()
      this.$message.success('重置成功！')
    },
    //删除图片事件
    handleRemove(file, imageList) {
      this.EditForm.picurl = ''
      this.$http
        // product
        .post('/api/user/delete_head_img?id=' + this.$route.query.id)
        .then(res => {
          var rcode = res.data.code
          // 返回
          if (rcode !== 200) {
            this.$message.error(res.data.msg)
          } else {
            // 清空上传图片
            this.$message.success('头像删除成功！')
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    //预览图片事件
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      console.log(this.dialogImageUrl)
      this.dialogVisible = true
    },
    //文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    handleChange(file, imageList) {
      if (imageList.length > 1) {
        //新头像占据首位
        imageList.splice(0, 1)
      }
    },
    //文件上传成功时的钩子
    handleSuccess(response, file, imageList) {
      if (response.code == 200) {
        this.$message.success(response.msg)
        //表单保存时最新上传头像写入变量
        this.EditForm.picurl = response.data
      } else {
        this.$message.error(response.msg)
      }
    },
    beforeUpload(file) {
      const isImage =
        file.type == 'image/png' ||
        file.type == 'image/jpg' ||
        file.type == 'image/jpeg' ||
        file.type == 'image/bmp'
      const isLt2M = file.size < 1024 * 1024 * 2
      if (!isImage) {
        this.$message.error('上传只能是png,jpg,jpeg,bmp格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isImage && isLt2M
    }
  }
}
</script>

<style>
.el-form {
  margin-top: 30px;
}
.EditdataForm {
  width: 460px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
